module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lt1Ds"))).then(() => module.bundle.root('dJXJK'));